{
  "id": "anchor",
  "text": "TIP_RESTRAINT",
  "variant": "locked",
  "src": "/proof/video/anchor.mp4",
  "poster": "/proof/video/anchor-poster.jpg",
  "posterTime": 5.0,
  "duration": 6.0,
  "fps": 24.0,
  "keyframes": [
    {
      "t": 0.0,
      "top": 0.2919,
      "left": 0.2479,
      "width": 0.4953,
      "height": 0.3913
    },
    {
      "t": 0.5,
      "top": 0.2893,
      "left": 0.2456,
      "width": 0.4995,
      "height": 0.3946
    },
    {
      "t": 1.0,
      "top": 0.2958,
      "left": 0.2659,
      "width": 0.5107,
      "height": 0.4035
    },
    {
      "t": 1.5,
      "top": 0.3324,
      "left": 0.2284,
      "width": 0.532,
      "height": 0.4203
    },
    {
      "t": 2.0,
      "top": 0.3178,
      "left": 0.1769,
      "width": 0.5569,
      "height": 0.44
    },
    {
      "t": 2.5,
      "top": 0.2714,
      "left": 0.1711,
      "width": 0.6008,
      "height": 0.4747
    },
    {
      "t": 3.0,
      "top": 0.2429,
      "left": 0.1686,
      "width": 0.6356,
      "height": 0.5022
    },
    {
      "t": 3.5,
      "top": 0.25,
      "left": 0.1449,
      "width": 0.6592,
      "height": 0.5207
    },
    {
      "t": 4.0,
      "top": 0.2316,
      "left": 0.159,
      "width": 0.6828,
      "height": 0.5395
    },
    {
      "t": 4.5,
      "top": 0.246,
      "left": 0.1272,
      "width": 0.693,
      "height": 0.5475
    },
    {
      "t": 5.0,
      "top": 0.2534,
      "left": 0.0965,
      "width": 0.696,
      "height": 0.5499
    },
    {
      "t": 5.5,
      "top": 0.2721,
      "left": 0.1094,
      "width": 0.6771,
      "height": 0.5349
    },
    {
      "t": 5.958,
      "top": 0.2901,
      "left": 0.1284,
      "width": 0.6538,
      "height": 0.5166
    }
  ]
}
